import React from 'react';
import styled from 'styled-components';
import { registry } from '../../core/Registry.js';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${props => props.align || 'center'};
  width: 100%;
  position: relative;
  gap: 15px;
  flex-wrap: nowrap;
  overflow-x: auto;
  padding: 20px 0;
  
  /* Blendet Scrollbar aus */
  &::-webkit-scrollbar { display: none; }
  -ms-overflow-style: none;
  scrollbar-width: none;
`;

const StepItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  min-width: 100px;
  flex: 1;

  /* Verbindungslinie (außer beim letzten) */
  &:not(:last-child)::after {
    content: '';
    position: absolute;
    top: 20px;
    left: 50%;
    width: 100%;
    height: 2px;
    background: ${props => props.active ? 'var(--accent)' : 'var(--glass-border)'};
    z-index: 1;
  }
`;

const Circle = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: ${props => props.active ? 'linear-gradient(135deg, var(--accent), var(--accent-neon))' : 'var(--glass-2)'};
  border: 2px solid ${props => props.active ? 'rgba(6,182,212,0.45)' : 'var(--glass-border)'};
  color: ${props => props.active ? '#fff' : 'var(--text-muted)'};
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 14px;
  z-index: 2;
  box-shadow: ${props => props.active ? '0 0 15px var(--accent-glow)' : 'none'};
`;

const StepLabel = styled.div`
  margin-top: 10px;
  font-size: 12px;
  font-weight: 600;
  color: ${props => props.active ? 'var(--text-primary)' : 'var(--text-muted)'};
  text-align: center;
`;

const StepDesc = styled.div`
  font-size: 10px;
  color: var(--text-muted);
  text-align: center;
  margin-top: 4px;
`;

const StepProcessWidget = ({ node }) => {
  const stepsRaw = node.content?.steps || "Schritt 1:Planung|Schritt 2:Design|Schritt 3:Entwicklung|Schritt 4:Launch";
  const activeStep = node.content?.activeStep || 2;
  const align = node.style?.desktop?.align || 'center';

  // Split steps by | and then by :
  const stepItems = stepsRaw.split('|').map(s => {
    const parts = s.split(':');
    return { title: parts[0] || 'Titel', desc: parts[1] || '' };
  });

  return (
    <Wrapper align={align}>
      {stepItems.map((step, idx) => {
        const isActive = (idx + 1) <= activeStep;
        return (
          <StepItem key={idx} active={isActive}>
            <Circle active={isActive}>{idx + 1}</Circle>
            <StepLabel active={isActive}>{step.title}</StepLabel>
            {step.desc && <StepDesc>{step.desc}</StepDesc>}
          </StepItem>
        );
      })}
    </Wrapper>
  );
};

registry.register('step_process', {
  label: 'Prozess Schritte',
  icon: '📈',
  category: 'advanced',
  defaultContent: {
    steps: "Bestellung:Heute|Versand:In 2 Tagen|Zustellung:In 4 Tagen",
    activeStep: 2
  },
  defaultStyle: {
    desktop: { align: 'center' }
  },
  render: StepProcessWidget,
  inspectorControls: [
    {
      tab: 'content',
      groups: [
        {
          title: 'Schritte Definition',
          fields: [
            { name: 'content.steps', label: 'Einträge (Format: Titel:Untertext|Titel2:Untertext)', type: 'textarea' },
            { name: 'content.activeStep', label: 'Aktiver Schritt (Zahl)', type: 'text' }
          ]
        }
      ]
    },
    {
      tab: 'style',
      groups: [
        {
          title: 'Layout',
          fields: [
            { name: 'style.desktop.align', label: 'Ausrichtung', type: 'select', options: [{label:'Links', value:'flex-start'}, {label:'Zentriert', value:'center'}] }
          ]
        }
      ]
    }
  ]
});
